import { connectFela } from '../../../../dependencies';
import RoleField from './RoleField';
import * as styles from './RoleField.styles';

export default connectFela(styles)(RoleField);
